var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("app-detail-header", {
        attrs: {
          "show-toggle": true,
          "show-new": false,
          "show-print":
            _vm.entitySummaries &&
            _vm.entitySummaries.returnPartsItem.length != 0,
          "show-delete":
            _vm.entitySummaries &&
            !_vm.entitySummaries.deleted &&
            !_vm.entitySummaries.isNew &&
            _vm.entitySummaries.returnPartsItem.length != 0,
          "show-save":
            !_vm.isSave &&
            _vm.entitySummaries &&
            _vm.entitySummaries.returnPartsItem.length != 0,
        },
        on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
      }),
      _c("div", { staticClass: "columns is-gapless" }, [
        _c(
          "div",
          { staticClass: "column is-narrow" },
          [
            _vm.entitySummaries
              ? _c("return-parts-side-menu", {
                  attrs: { "is-new": _vm.entitySummaries.isNew },
                  on: {
                    changedetail: function ($event) {
                      return _vm.changeVendorDetail($event)
                    },
                    filter: function ($event) {
                      return _vm.filterList($event)
                    },
                    reset: _vm.resetList,
                  },
                  model: {
                    value: _vm.filter,
                    callback: function ($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "tile is-parent" }, [
            _c(
              "article",
              { staticClass: "tile is-child box" },
              [
                _vm.entitySummaries
                  ? _c("return-parts-detail", {
                      attrs: {
                        "vendor-filter": _vm.filter,
                        "read-only": _vm.readOnly,
                      },
                      model: {
                        value: _vm.entitySummaries,
                        callback: function ($$v) {
                          _vm.entitySummaries = $$v
                        },
                        expression: "entitySummaries",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "tile is-horizontal" }, [
            _c("div", { staticClass: "tile is-parent is-5" }, [
              _c(
                "article",
                { staticClass: "tile is-child box" },
                [
                  _vm.entitySummaries
                    ? _c("return-parts-detail-value", {
                        attrs: {
                          "vendor-abn": _vm.entitySummaries.vendorAbn,
                          "return-no":
                            _vm.entitySummaries.prefix +
                            _vm.entitySummaries.creditNo,
                          "vendor-id": _vm.entitySummaries.vendorId,
                          "return-date": _vm.entitySummaries.returnDate,
                          "read-only": _vm.readOnly,
                        },
                        on: {
                          changevalue: function ($event) {
                            return _vm.changeEntity($event)
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "tile is-parent" }, [
              _c(
                "article",
                { staticClass: "tile is-child box" },
                [
                  _vm.entitySummaries
                    ? _c("return-parts-remarks", {
                        attrs: { "read-only": _vm.readOnly },
                        model: {
                          value: _vm.entitySummaries,
                          callback: function ($$v) {
                            _vm.entitySummaries = $$v
                          },
                          expression: "entitySummaries",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
      _c(
        "unsaved-modal",
        {
          attrs: { active: _vm.isUnsavedModalActive },
          on: {
            "update:active": function ($event) {
              _vm.isUnsavedModalActive = $event
            },
            close: function ($event) {
              return _vm.closeModal()
            },
            skipSave: function ($event) {
              return _vm.skipSave()
            },
            saveContinue: function ($event) {
              return _vm.saveContinue()
            },
          },
        },
        [
          _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
            _vm._v("Unsaved Changes"),
          ]),
          _c("p", { attrs: { slot: "text-content" }, slot: "text-content" }, [
            _vm._v("There are unsaved changes. Please select action below"),
          ]),
        ]
      ),
      _c(
        "save-conflict-modal",
        {
          attrs: { active: _vm.isSaveConflictModalActive },
          on: {
            "update:active": function ($event) {
              _vm.isSaveConflictModalActive = $event
            },
            close: function ($event) {
              return _vm.closeModal()
            },
            reload: function ($event) {
              return _vm.reloadData()
            },
          },
        },
        [
          _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
            _vm._v("Change conflict"),
          ]),
          _c("p", { attrs: { slot: "text-content" }, slot: "text-content" }, [
            _vm._v(
              "The data on the server is newer than the local copy. Please reload local data."
            ),
          ]),
        ]
      ),
      _vm.entitySummaries
        ? _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isConfirmModalActive,
                "ok-text": "Yes",
                "cancel-text": "No",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isConfirmModalActive = $event
                },
                ok: function ($event) {
                  return _vm.deleteEntity(true)
                },
                cancel: function ($event) {
                  return _vm.deleteEntity(false)
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Delete Return Part"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm._v(" Return Part No: "),
                  _c(
                    "span",
                    { staticClass: "has-text-primary has-text-weight-bold" },
                    [
                      _vm._v(
                        _vm._s(
                          `${_vm.entitySummaries.prefix}${_vm.entitySummaries.creditNo}`
                        )
                      ),
                    ]
                  ),
                  _vm._v(" will be deleted. Continue? "),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }